// extracted by mini-css-extract-plugin
export default {"summary":"TaskLinkFilePage_summary__7FNZW","title":"TaskLinkFilePage_title__2P07h"};